export const ignoreErrorStrings = [
  "plugin is not implemented on",
  "Not implemented on web.",
  "Cannot read properties of undefined (reading 'message')",
  //https://sentry.io/answers/react-resizeobserver-loop-completed-with-undelivered-notifications/
  "ResizeObserver loop limit exceeded",
];
